(() => {
  function initializeBoujeeStudioTheme() {
    const body = document.body;

    if (body.dataset.boujeeThemeInitialized === "true") {
      return;
    }

    body.dataset.boujeeThemeInitialized = "true";

    const modal = document.getElementById("fit-modal");
    const closeButton = document.getElementById("modal-close");

    const stickyInquiry = document.getElementById("sticky-inquiry");
    const mobileInquiry = document.getElementById("mobile-inquiry");

    const systemCard = document.getElementById("system-card");
    const systemToggle = document.getElementById("system-toggle");

    const systemKicker = document.getElementById("system-kicker");
    const systemStatus = document.getElementById("system-status");
    const systemState = document.getElementById("system-state");
    const systemDescription = document.getElementById("system-description");

    const ownerLabel = document.getElementById("owner-label");
    const ownerTitle = document.getElementById("owner-title");
    const ownerSubtitle = document.getElementById("owner-subtitle");

    const bottomLabel = document.getElementById("bottom-label");
    const bottomTitle = document.getElementById("card-bottom-title");
    const toggleLabel = document.getElementById("system-toggle-label");

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    let systemIsConnected = false;

    function setFitStep(step) {
      document.querySelectorAll(".fit-step").forEach((element) => {
        element.classList.toggle(
          "active",
          Number(element.dataset.step) === step
        );
      });

      document.querySelectorAll(".fit-progress span").forEach(
        (element, index) => {
          element.classList.toggle("active", index < step);
        }
      );
    }

    function openFitModal() {
      if (!modal) {
        return;
      }

      modal.classList.add("open");
      body.classList.add("modal-open");

      setFitStep(1);
    }

    function closeFitModal() {
      if (!modal) {
        return;
      }

      modal.classList.remove("open");
      body.classList.remove("modal-open");
    }

    document.querySelectorAll(".open-fit").forEach((button) => {
      button.addEventListener("click", openFitModal);
    });

    if (stickyInquiry) {
      stickyInquiry.addEventListener("click", openFitModal);
    }

    if (mobileInquiry) {
      mobileInquiry.addEventListener("click", openFitModal);
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeFitModal);
    }

    if (modal) {
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          closeFitModal();
        }
      });
    }

    document.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        modal &&
        modal.classList.contains("open")
      ) {
        closeFitModal();
      }
    });

    document.querySelectorAll(".fit-next").forEach((button) => {
      button.addEventListener("click", () => {
        const activeStep = document.querySelector(".fit-step.active");

        if (!activeStep) {
          return;
        }

        const requiredField = activeStep.querySelector("[required]");

        if (requiredField && !requiredField.checkValidity()) {
          requiredField.reportValidity();
          return;
        }

        setFitStep(2);
      });
    });

    document.querySelectorAll(".fit-back").forEach((button) => {
      button.addEventListener("click", () => {
        setFitStep(1);
      });
    });

    function updateSystemCard() {
      if (!systemCard) {
        return;
      }

      systemCard.classList.toggle("is-connected", systemIsConnected);

      if (systemKicker) {
        systemKicker.textContent = systemIsConnected
          ? "The Boujee Studio model"
          : "The current reality";
      }

      if (systemStatus) {
        systemStatus.textContent = systemIsConnected
          ? "Connected"
          : "Disconnected";
      }

      if (systemState) {
        systemState.innerHTML = systemIsConnected
          ? "One commercial plan.<br>One strategic owner."
          : "Every channel is active.<br>No one owns the product journey.";
      }

      if (systemDescription) {
        systemDescription.textContent = systemIsConnected
          ? "DTC, Amazon, Walmart.com, retail, and product experience now support the same customer outcome."
          : "Good work is happening in separate lanes.";
      }

      if (ownerLabel) {
        ownerLabel.textContent = systemIsConnected
          ? "Strategic owner"
          : "Owner";
      }

      if (ownerTitle) {
        ownerTitle.textContent = systemIsConnected
          ? "Boujee Studio"
          : "You";
      }

      if (ownerSubtitle) {
        ownerSubtitle.textContent = systemIsConnected
          ? "Clear direction"
          : "Forced to coordinate";
      }

      if (bottomLabel) {
        bottomLabel.textContent = systemIsConnected
          ? "The outcome"
          : "The result";
      }

      if (bottomTitle) {
        bottomTitle.innerHTML = systemIsConnected
          ? "Clear priorities.<br>Better product experiences."
          : "Too many moving parts.<br>No shared plan.";
      }

      if (toggleLabel) {
        toggleLabel.textContent = systemIsConnected
          ? "View the current reality"
          : "See the connected model";
      }

      if (systemToggle) {
        systemToggle.setAttribute(
          "aria-pressed",
          systemIsConnected ? "true" : "false"
        );
      }
    }

    function setSystemState(connected) {
      systemIsConnected = connected;
      updateSystemCard();
    }

    if (systemToggle) {
      systemToggle.addEventListener("click", () => {
        setSystemState(!systemIsConnected);
      });
    }

    if (systemCard) {
      if (prefersReducedMotion) {
        setSystemState(true);
      } else {
        window.setTimeout(() => {
          setSystemState(true);
        }, 2200);
      }
    }

    function updateStickyInquiry() {
      const shouldShow =
        window.scrollY > window.innerHeight * 0.48 &&
        !body.classList.contains("modal-open");

      if (stickyInquiry) {
        stickyInquiry.classList.toggle("visible", shouldShow);
      }

      if (mobileInquiry) {
        mobileInquiry.classList.toggle("visible", shouldShow);
      }
    }

    function addRevealTargets() {
      const selectors = [
        ".hero-content",
        ".system-card",
        ".commerce-review-intro",
        ".commerce-review-card",
        ".problem-header",
        ".problem",
        ".support-overview-header",
        ".support-overview-card",
        ".solution-card",
        ".solution-copy",
        ".founder-inner",
        ".closing-inner",
        ".operating",
        ".support-tier-header",
        ".support-tier",
        ".review-deliverable",
        ".channel-direction-card",
        ".guardrail-grid article",
        ".commerce-review-summary > *",
        ".review-channel-layout > *",
        ".review-scope-layout > *",
        ".marketplace-principle > *",
        ".marketplace-work-layout > *",
        ".contact-card",
        ".contact-layout form"
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          element.classList.add("reveal-on-scroll");
        });
      });
    }

    function setupRevealObserver() {
      const elements = document.querySelectorAll(".reveal-on-scroll");

      if (prefersReducedMotion || !("IntersectionObserver" in window)) {
        elements.forEach((element) => {
          element.classList.add("is-visible");
        });

        return;
      }

      const observer = new IntersectionObserver(
        (entries, activeObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add("is-visible");
            activeObserver.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: "0px 0px -10% 0px",
          threshold: 0.08
        }
      );

      elements.forEach((element) => {
        observer.observe(element);
      });
    }

    function startHeroEntrance() {
      const heroContent = document.querySelector(".hero-content");

      if (prefersReducedMotion) {
        if (heroContent) {
          heroContent.classList.add("is-visible");
        }

        if (systemCard) {
          systemCard.classList.add("is-visible");
        }

        return;
      }

      window.setTimeout(() => {
        if (heroContent) {
          heroContent.classList.add("is-visible");
        }
      }, 80);

      window.setTimeout(() => {
        if (systemCard) {
          systemCard.classList.add("is-visible");
        }
      }, 190);
    }

    addRevealTargets();
    setupRevealObserver();
    startHeroEntrance();
    updateStickyInquiry();

    window.addEventListener("scroll", updateStickyInquiry, {
      passive: true
    });

    window.addEventListener("resize", updateStickyInquiry);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeBoujeeStudioTheme
    );
  } else {
    initializeBoujeeStudioTheme();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeBoujeeStudioTheme
  );
})();